// extracted by mini-css-extract-plugin
export default {"inputRow":"EditRegate_inputRow__v2-oe"};